module.exports = __webpack_public_path__ + "img/brown-asterisk-21.07439e30.png";